var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.ready ? _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "shop-board-view",
    attrs: {
      "max-width": "1024px",
      "width": "100%",
      "height": "100%"
    }
  }, [!_vm.$route.query._board ? _c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm._v("게시글 등록")]) : _c('div', {
    staticClass: "headline text-start mt-8"
  }, [_vm._v("게시글 상세")]), _vm.$route.query._board ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("작성자 정보")]), _c('v-card-text', {
    staticClass: "pb-6"
  }, [['interior-inquire'].includes(_vm.$route.params.code) ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.board.user.name,
      "label": "이름",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.board.user.phone,
      "label": "연락처",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.board.user.email,
      "label": "이메일",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    }
  })], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("기본정보")]), _c('v-card-text', {
    staticClass: "pb-6"
  }, [['support', 'interior-inquire', 'event'].includes(_vm.$route.params.code) ? _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.subject,
      callback: function ($$v) {
        _vm.$set(_vm.board, "subject", $$v);
      },
      expression: "board.subject"
    }
  })], 1), ['interior-inquire'].includes(_vm.$route.params.code) ? _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "작성일",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.createDate,
      callback: function ($$v) {
        _vm.$set(_vm.board, "createDate", $$v);
      },
      expression: "board.createDate"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), ['event'].includes(_vm.$route.params.code) ? _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['진행중 이벤트', '종료된 이벤트'],
      "label": "카테고리",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.category,
      callback: function ($$v) {
        _vm.$set(_vm.board, "category", $$v);
      },
      expression: "board.category"
    }
  })], 1)], 1) : _vm._e(), ['event'].includes(_vm.$route.params.code) ? _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기간",
      "placeholder": "ex) 2020-01-01 ~ 2020.12.31",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.period,
      callback: function ($$v) {
        _vm.$set(_vm.board, "period", $$v);
      },
      expression: "board.period"
    }
  })], 1)], 1) : _vm._e(), ['support', 'interior-shop', 'event'].includes(_vm.$route.params.code) ? _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "한줄설명",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.summary,
      callback: function ($$v) {
        _vm.$set(_vm.board, "summary", $$v);
      },
      expression: "board.summary"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), ['support', 'event'].includes(_vm.$route.params.code) ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("썸네일")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.board.thumb || _vm.board.thumbFile ? _c('v-img', {
    attrs: {
      "width": "283",
      "height": "185",
      "src": _vm.board.thumbFile ? _vm.createObjectURL(_vm.board.thumbFile) : _vm.board.thumb,
      "contain": ""
    }
  }) : _c('v-responsive', {
    staticClass: "grey lighten-2",
    attrs: {
      "width": "283",
      "height": "185"
    }
  }, [_c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1), _c('v-col', {
    staticClass: "py-0"
  }, [_c('v-file-input', {
    staticClass: "mt-2 mx-3",
    attrs: {
      "label": "썸네일 이미지",
      "placeholder": " ",
      "show-size": "",
      "accept": "image/*"
    },
    model: {
      value: _vm.board.thumbFile,
      callback: function ($$v) {
        _vm.$set(_vm.board, "thumbFile", $$v);
      },
      expression: "board.thumbFile"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), ['interior-shop'].includes(_vm.$route.params.code) ? _c('v-card', {
    staticClass: "mt-4"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("상세정보")]), _c('v-card-text', {
    staticClass: "pb-6"
  }, [_c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "취급점명",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.storeName,
      callback: function ($$v) {
        _vm.$set(_vm.board, "storeName", $$v);
      },
      expression: "board.storeName"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "연락처",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.storePhone,
      callback: function ($$v) {
        _vm.$set(_vm.board, "storePhone", $$v);
      },
      expression: "board.storePhone"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "이메일",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.storeEmail,
      callback: function ($$v) {
        _vm.$set(_vm.board, "storeEmail", $$v);
      },
      expression: "board.storeEmail"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sidoGugun,
      "item-text": "name",
      "label": "시/도",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.sido,
      callback: function ($$v) {
        _vm.$set(_vm.board, "sido", $$v);
      },
      expression: "board.sido"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.board.sido ? _vm.sidoGugun.find(function (sido) {
        return sido.name == _vm.board.sido;
      }).gugun : [],
      "item-text": "name",
      "label": "구/군",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.gugun,
      callback: function ($$v) {
        _vm.$set(_vm.board, "gugun", $$v);
      },
      expression: "board.gugun"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "지역",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.area,
      callback: function ($$v) {
        _vm.$set(_vm.board, "area", $$v);
      },
      expression: "board.area"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "우편번호",
      "placeholder": " ",
      "dense": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": _vm.searchPostcode
    },
    model: {
      value: _vm.board.postcode,
      callback: function ($$v) {
        _vm.$set(_vm.board, "postcode", $$v);
      },
      expression: "board.postcode"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-6"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "기본주소",
      "placeholder": " ",
      "dense": "",
      "hide-details": "",
      "readonly": ""
    },
    on: {
      "click": _vm.searchPostcode
    },
    model: {
      value: _vm.board.address1,
      callback: function ($$v) {
        _vm.$set(_vm.board, "address1", $$v);
      },
      expression: "board.address1"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "상세주소",
      "placeholder": " ",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.address2,
      callback: function ($$v) {
        _vm.$set(_vm.board, "address2", $$v);
      },
      expression: "board.address2"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), ['interior-shop'].includes(_vm.$route.params.code) ? _c('board-collections', {
    model: {
      value: _vm.board,
      callback: function ($$v) {
        _vm.board = $$v;
      },
      expression: "board"
    }
  }) : _vm._e(), ['support', 'interior-shop', 'interior-inquire'].includes(_vm.$route.params.code) ? _c('board-relative-products', {
    model: {
      value: _vm.board,
      callback: function ($$v) {
        _vm.board = $$v;
      },
      expression: "board"
    }
  }) : _vm._e(), ['interior-shop'].includes(_vm.$route.params.code) ? _c('board-portfolios', {
    model: {
      value: _vm.board,
      callback: function ($$v) {
        _vm.board = $$v;
      },
      expression: "board"
    }
  }) : _vm._e(), _c('v-card', {
    staticClass: "mt-6"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("내용")]), _c('v-card-text', [_c('naver-smarteditor', {
    attrs: {
      "id": "content",
      "rows": "30"
    },
    model: {
      value: _vm.board.content,
      callback: function ($$v) {
        _vm.$set(_vm.board, "content", $$v);
      },
      expression: "board.content"
    }
  })], 1)], 1), ['interior-inquire'].includes(_vm.$route.params.code) ? _c('v-card', {
    staticClass: "mt-6"
  }, [_c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("답변")]), _c('v-card-text', [_c('naver-smarteditor', {
    attrs: {
      "id": "reply",
      "rows": "30"
    },
    model: {
      value: _vm.board.reply,
      callback: function ($$v) {
        _vm.$set(_vm.board, "reply", $$v);
      },
      expression: "board.reply"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "change": _vm.changePostcode
    }
  })], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }